<template>
  <div>
    <button
      class="invisible-button full-button_mb"
      @click="exportCsv"><svg-download /> Export tasks to CSV</button>
  </div>
</template>

<script>
import { slugify } from '../mixins/slugify'
import Download from '../svgs/Download'
import moment from 'moment'

export default {
  components: {
    svgDownload: Download
  },
  mixins: [ slugify ],
  props: {
    page: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }
  },
  computed: {
    csv () {
      return this.$store.getters.estimateCsv(this.page)
    }
  },
  methods: {
    exportCsv () {
      let csv = this.csv
      const filename = this.slugify(this.name) + '_' + moment().format('YYYY-MM-DDTHH:mm') + '.csv'
      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv
      }
      const data = encodeURI(csv)
      let link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', filename)
      link.click()
    }
  }
}
</script>
